const ArrowLeftLogin = ({ size = 24, fill = '#231F20', ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19 11.5H7.82998L12.71 6.61997C13.1 6.22997 13.1 5.58997 12.71 5.19997C12.32 4.80997 11.69 4.80997 11.3 5.19997L4.70998 11.79C4.31998 12.18 4.31998 12.81 4.70998 13.2L11.3 19.79C11.69 20.18 12.32 20.18 12.71 19.79C13.1 19.4 13.1 18.77 12.71 18.38L7.82998 13.5H19C19.55 13.5 20 13.05 20 12.5C20 11.95 19.55 11.5 19 11.5Z"
        fill={fill}
      />
    </svg>
  );
};

export default ArrowLeftLogin;
